namespace GeniuzPOS.SalePromoCamp {
    export interface PsPromoDaysRow {
        Id?: number;
        PromoId?: string;
        PromoDay?: number;
    }

    export namespace PsPromoDaysRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PromoId';
        export const localTextPrefix = 'SalePromoCamp.PsPromoDays';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PromoId = "PromoId",
            PromoDay = "PromoDay"
        }
    }
}
